import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import Global from '../../../store/global-selectors';
import * as GridConfigApi from '../../../store/grid-config.api';
import * as OrdersActions from '../../../store/orders/orders.actions';
import * as NavActions from '../../../store/orders/nav/orders.nav.actions';
import { ModalService } from 'ui-components/services/modal-service';
import { orderGridChangeColumns } from '../../../store/orders/grid/orders.grid.actions';
import { saveUserSettingGridConfig } from '../../../store/user/user.actions';
import { DeleteOrdersFilterviewModalContainer } from '../../../containers/delete-orders-filterview-modal-container';
import { EditOrdersFilterviewModalContainer } from '../../../containers/edit-orders-filterview-modal-container';
import { SaveOrdersFilterviewModalContainer } from '../../../containers/save-orders-filterview-modal-container';
import * as Actions from './orders.filtering.actions';

export const updateGridWithNoFilters = (action$) => {
  return action$.pipe(
    ofType(
      Actions.ORDERS_AUTOSWITCH_FILTERVIEW_DEFAULT,
      Actions.ORDERS_DELETE_FILTERVIEW_SUCCESS,
      Actions.ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS,
      Actions.ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS,
    ),
    map(() => {
      return OrdersActions.requestGetOrders();
    }),
  );
};

export const switchActiveFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.ORDERS_SWITCH_FILTERVIEW, Actions.APPLY_FILTER_SET),
    mergeMap(() => {
      return of(NavActions.clearSearchInput(), OrdersActions.requestGetOrders());
    }),
  );
};

export const getSavedFilterViewsRequest = (action$) => {
  return action$.pipe(
    ofType(Actions.ORDERS_GET_SAVED_FILTERVIEWS_REQUEST),
    mergeMap(() => {
      return GridConfigApi.getAllOrdersGridConfigs().pipe(
        map((savedFilterViews) => {
          return Actions.getSavedFilterViewsSuccess(savedFilterViews);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const saveNewFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.ORDERS_SAVE_NEW_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveNewOrdersGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveNewFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const saveExistingFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.ORDERS_SAVE_EXISTING_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveExistingOrdersGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveExistingFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const updateSavedViewGridConfig = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS, Actions.ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS),
    mergeMap((action) => {
      const state = getState();
      const { filterView } = action;
      const { gridViewId, filterViewId } = filterView;
      const gridConfig = Global.selectOrdersGridCurrentViewGridConfigOrDefault(state, {
        statusViewId: gridViewId,
        activeFilterViewId: 'custom',
      });

      return of(
        orderGridChangeColumns(gridViewId, filterViewId, gridConfig),
        saveUserSettingGridConfig('orders', gridViewId, filterViewId, gridConfig),
      );
    }),
  );
};

export const deleteFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.ORDERS_DELETE_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      const { filterView } = action;
      return GridConfigApi.deleteGridConfig(filterView).pipe(
        map(() => {
          return Actions.deleteFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const launchSaveOrdersViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_ORDERS_SAVE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: SaveOrdersFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchEditOrdersViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_ORDERS_EDIT_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: EditOrdersFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchDeleteOrdersViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_ORDERS_DELETE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: DeleteOrdersFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};
